import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

interface ErrorStateProps {
  title?: string;
  message: string;
  onRetry?: () => void;
  retryText?: string;
  className?: string;
}

const ErrorState = ({
  title = 'Something went wrong',
  message,
  onRetry,
  retryText = 'Try Again',
  className = ''
}: ErrorStateProps) => {
  return (
    <div className={`flex flex-col items-center justify-center text-center py-12 px-4 ${className}`}>
      <div className="mx-auto w-16 h-16 text-red-400 mb-4">
        <ExclamationTriangleIcon className="w-full h-full" />
      </div>
      
      <h3 className="text-lg font-medium text-m2-on-surface mb-2">
        {title}
      </h3>
      
      <p className="text-m2-on-surface-variant mb-6 max-w-md">
        {message}
      </p>
      
      {onRetry && (
        <button
          onClick={onRetry}
          className="btn-primary"
        >
          {retryText}
        </button>
      )}
    </div>
  );
};

export default ErrorState;